import {Modal} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {modalCRUDService} from "../services/modalCRUDService";
import {modalSideService} from "../services/modalSideService";
import {routesFormSideModal} from "../data/RoutesFormCrud";
import {isEmpty} from "../util/is";
import { useHistory } from "react-router-dom";


const defaultId = 'defaultModalSide';

const RenderForm = ({props, type}) => {

  const { isEditing, isAddMode, isAddModeFromNode, properties } = props;
  const Component = routesFormSideModal[type];

  if(isEmpty(Component)){
    return (
      <div>
        No existe el formulario, debes crearlo en views/formularios y asociarlos en data/RoutesFormCrud
      </div>
    )
  }

  return (<Component isEditing={isEditing} isAddMode={isAddMode} properties={properties} isAddModeFromNode={isAddModeFromNode} />)

}

const ModalSide = ({id = defaultId}) => {

    let history = useHistory();
    const [modalSide, setModalSide] = useState(null);

    useEffect(() => {

        const subscription = modalSideService.onModalSide(id)
            .subscribe(modalSide=> {
                if (!modalSide.type) {
                    setModalSide(null);
                } else {
                    setModalSide(modalSide);
                }
        });

        const historyUnlisten = history.listen(() => {
            modalSideService.clear(id);
        });

        return () => {
            subscription.unsubscribe();
            historyUnlisten();
        };

    }, []);

    const removeModalSide = () => {
        setModalSide(null);
    }

    if (!modalSide) return null;

    return (
        <Modal
        id={modalSide.id}
        size={modalSide.size}
        show={true}
        onHide={() => removeModalSide()}
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        dialogClassName="modal-side"
        >
        <Modal.Header className="headerModal" closeButton>
            <a className="icon-container">
                <div/>
                {modalSide.isAddMode?
                    <i className="fas fa-plus"/>
                    :
                 modalSide.isEditable?
                    <i className="fas fa-pen"/>
                    :
                    <i className="fas fa-eye"/>
                }
            </a>
            <Modal.Title>
                {modalSide.title}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body className={!modalSide.dense?'p-0':''}>
          <RenderForm type={modalSide.type} props={{
            isEditing: modalSide.isEditable,
            isAddMode: modalSide.isAddMode,
            isAddModeFromNode: modalSide.isAddModeFromNode,
            properties: {...modalSide.props, idModal: modalSide.id}
          }} />
        </Modal.Body>
    </Modal>)


}


export { ModalSide };
